import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  eyebrow?: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  title,
  eyebrow,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="min-w-0">
        {eyebrow ? (
          <p className="mb-1.5 flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            {eyebrow}
          </p>
        ) : null}
        <h2 className="font-heading text-xl text-foreground-950 md:text-2xl">{title}</h2>
        {description ? (
          <p className="mt-1.5 max-w-2xl text-xs leading-relaxed text-foreground-500 md:text-[13px]">
            {description}
          </p>
        ) : null}
      </div>
      {actionLabel && actionTo ? (
        <Link
          to={actionTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-3.5 py-1.5 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      ) : null}
    </div>
  );
}